import { Empty } from 'vant';
import Navbar from '@/components/Navbar.vue';
export default {
  name: 'NotFound',
  components: {
    [Empty.name]: Empty,
    Navbar
  }
};